import * as React from 'react';
import IMembersPortalComponentDataItem from '../../../../redux/types/IMembersPortalComponentDataItem';
import { mp_addTab } from '../../../../redux/reducers/MembersPortalReducer';
import { MemberStatementWorksGrid } from '../statementDetailsGrid/MemberStatementWorksGrid';
import { MembersPortalService } from '../../../../redux/services/MembersPortalService';
import { IMemberStatementWorkState } from '../../../../redux/types/IMemberStatementState';

export interface IMemberStatementUsageDetailsPageProps {
    workDetailGridsComponentData: IMembersPortalComponentDataItem;
    workPageComponentData: IMembersPortalComponentDataItem;
    addTab: typeof mp_addTab;
    userNameNumber: string;
    description: string;
    memberStatementWorkState: IMemberStatementWorkState
}

export const MemberStatementWorksPage: React.FC<IMemberStatementUsageDetailsPageProps> = (props: IMemberStatementUsageDetailsPageProps) => {

    const [viewData, setViewData] = React.useState({});

    React.useEffect(() => {
        const {
            workPageComponentData: { fields }
        } = props;
        let data = {}
        if (fields) {
            const visibleFields = fields.filter(field => !field.hidden);

            visibleFields.forEach(item => {
                data[item.name] = item.data;

                if (Object.keys(data).length === visibleFields.length) {
                    setViewData(data);
                }
            });
        }
    }, [])


    const { distributionCode, poolCode, segment, paymentRunCode } = props.memberStatementWorkState ?? {};
    
    return (
        <div>
            <div><span className="title">{viewData['works']} {distributionCode} {poolCode} {segment}</span></div>
            <div><span className='subtitle'>{viewData['payment']}  {paymentRunCode}</span></div>
            <div><span>{props.description}</span></div>
            <br />
            <MemberStatementWorksGrid
                addTab={props.addTab}
                description={props.description}
                workDetailGridsComponentData={props.workDetailGridsComponentData}
                segment={segment}
                memberStatementWorkState={props.memberStatementWorkState}
                userNameNumber={props.userNameNumber}
            />
        </div>
    )

}